/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFunctionAssignmentNode } from '../../factoriesAny.js';
export var FunctionAssignmentNodeDependencies = {
  NodeDependencies: NodeDependencies,
  typedDependencies: typedDependencies,
  createFunctionAssignmentNode: createFunctionAssignmentNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFunctionAssignmentNode.generated.js
// module id = 631
// module chunks = 0